'use client';

import { Button } from '@/components/ui/button';
import { useNotifications } from '@/hooks/useNotifications';
import { Bell } from 'lucide-react';

export default function HeaderNotificationButton() {
  const { permission, isLoading, isIOSNonPWA, requestPermission, removePermission } = useNotifications();

  const handleClick = async () => {
    if (permission === 'granted') {
      await removePermission();
    } else if (permission === 'default') {
      await requestPermission();
    }
  };

  if (permission === 'denied' || isIOSNonPWA) {
    return null;
  }

  return (
    <Button
      onClick={handleClick}
      disabled={isLoading}
      variant='ghost'
      className={`relative h-8 w-8 p-0 ${
        permission === 'granted' ? 'text-emerald-600 hover:text-emerald-700' : 'text-gray-600 hover:text-primary-700'
      }`}
      isLoading={isLoading}>
      <Bell className='h-5 w-5' />
      {permission === 'granted' && <div className='absolute -right-1 -top-1 h-2 w-2 rounded-full bg-emerald-500' />}
    </Button>
  );
}
